import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { LandingPageSectionHeadlineModule } from '@landing-page/components/headline/landing-page-section-headline.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { LandingPageQuotesComponent } from './landing-page-quotes.component'

@NgModule({
    declarations: [LandingPageQuotesComponent],
    imports: [
        CommonModule,
        TranslationModule,
        LandingPageSectionHeadlineModule,
        LandingPageSectionContainerModule,
    ],
    exports: [LandingPageQuotesComponent],
})
export class LandingPageQuotesModule {}
